module.exports = __webpack_public_path__ + "img/button_green.2a08806e.png";